/*
 * Copyright (c) 2026 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */

/** The ID of the script element that loads the GTM container. */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();export const GTM_SCRIPT_ID = 'mta-gtm'

/** The shape of a GTM container ID. */
const GTM_ID_PATTERN = /^GTM-[A-Z0-9]+$/

/**
 * Defines `window.gtag` and queues the default consent state. Consent is granted for analytics and advertising. Does
 * nothing if `gtag` is already defined, so the default is only queued once.
 */
const initialiseGtag = (): void => {
  if (window.gtag !== undefined) {
    return
  }

  window.gtag = function () {
    // biome-ignore lint/complexity/noArguments: Google specifies Arguments objects for its command queue.
    window.dataLayer.push(arguments)
  }

  window.gtag('consent', 'default', {
    analytics_storage: 'granted',
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
  })
}

/**
 * Queues the `gtm.js` start event and loads the GTM container. All Pages triggers in GTM fire on this event.
 *
 * @param id - the GTM container ID
 */
const loadContainer = (id: string): void => {
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

  const script = document.createElement('script')
  script.id = GTM_SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`

  document.head.appendChild(script)
}

/**
 * Sets up Google Tag Manager: queues the default consent, then the start event, then loads the container. Safe to call
 * more than once; the container is only loaded on the first call.
 *
 * @param id - the GTM container ID
 */
export const initialiseGoogleTagManager = (id: string): void => {
  if (!GTM_ID_PATTERN.test(id)) {
    console.warn(`[Google Tag Manager]: Invalid container ID "${id}". GTM will not load.`)
    return
  }

  window.dataLayer = window.dataLayer || []
  initialiseGtag()

  if (document.getElementById(GTM_SCRIPT_ID)) {
    return
  }

  loadContainer(id)
}
